import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { getStorageJSON } from "../../utils/helpers";

export default function Wishlist() {
  const navigate = useNavigate();
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    const syncWishlist = () => {
      const data = getStorageJSON("wishlist", []);
      setWishlist(Array.isArray(data) ? data : []);
    };

    syncWishlist();
    window.addEventListener("wishlist-updated", syncWishlist);
    window.addEventListener("storage", syncWishlist);

    return () => {
      window.removeEventListener("wishlist-updated", syncWishlist);
      window.removeEventListener("storage", syncWishlist);
    };
  }, []);

  const removeItem = (id) => {
    const nextWishlist = wishlist.filter((item) => item.id !== id);
    setWishlist(nextWishlist);
    localStorage.setItem("wishlist", JSON.stringify(nextWishlist));
    window.dispatchEvent(new Event("wishlist-updated"));
  };

  return (
    <div className="home">
      <Navbar />

      <div className="customer-page">
        <div className="customer-page-header">
          <h2>Wishlist</h2>
          <p>Your saved favorites are here.</p>
        </div>

        {!wishlist.length ? (
          <div className="empty-state">
            <h3>No wishlist items</h3>
            <p>Tap the heart icon on any item to save it.</p>
            <button className="primary-action" onClick={() => navigate("/home")}>Explore Items</button>
          </div>
        ) : (
          <div className="customer-grid">
            {wishlist.map((item) => (
              <article className="customer-card" key={item.id}>
                <h3>{item.name || "Item"}</h3>
                <p>Category: {item.category || "snacks"}</p>
                <div className="page-actions">
                  <button className="secondary-action" onClick={() => removeItem(item.id)}>Remove</button>
                  <button className="primary-action" onClick={() => navigate("/home")}>View Item</button>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
